import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Star, MapPin } from 'lucide-react';
export function TestimonialsLong() {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Buenos Aires',
    child: 'Mamá de Tomás, 5 años',
    text: 'Compré un sábado a la noche. El domingo ya entendía por qué mi hijo explotaba en el supermercado. El Tomo 1 me explicó en 20 minutos lo que 3 años de crianza no me habían podido explicar.'
  }, {
    initials: 'LC',
    name: 'Laura C.',
    location: 'Medellín',
    child: 'Mamá de Sofía, 8 años',
    text: 'El Tomo 3 del aprendizaje me cambió la relación con las tareas. Mi hija tiene elemento Tierra y yo la estaba apurando como si fuera de Fuego. En dos semanas la dinámica cambió completamente.'
  }, {
    initials: 'PR',
    name: 'Patricia R.',
    location: 'Ciudad de México',
    child: 'Mamá de 3 hijos',
    text: 'Tengo tres hijos con elementos distintos. Antes pensaba que el del medio era el problema. Ahora entiendo que simplemente era el que más diferente era de mí. El Diccionario de Berrinches es mi biblia diaria.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Santiago de Chile',
    child: 'Mamá de Mateo, 6 años',
    text: 'Los bonus son increíbles. El Calma en 10 lo uso antes de responderle cuando ya estoy al límite. Bajé mis niveles de culpa un 80%. No exagero.'
  }, {
    initials: 'VP',
    name: 'Valeria P.',
    location: 'Montevideo',
    child: 'Mamá de Lucía, 4 años',
    text: 'Mi hija tiene elemento Agua y yo soy de Fuego. Éramos opuestas totales y no lo sabía. Ahora adapto mi tono y mis tiempos a los de ella. La conexión que tenemos hoy no tiene comparación.'
  }, {
    initials: 'AS',
    name: 'Ana S.',
    location: 'Bogotá',
    child: 'Mamá de Felipe, 7 años',
    text: 'Pensé que era demasiado barato para ser bueno. Me equivoqué por completo. Son más de 400 páginas de contenido real y aplicable. Vale 10 veces lo que cuesta. No entiendo cómo no lo conocía antes.'
  }];
  return <SectionWrapper className="bg-white/40 border-y border-dusty-rose/20" data-id="element-250">
      <div className="text-center mb-16" data-id="element-251">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-burgundy mb-4" data-id="element-252">
          Lo que dicen las mamás que ya lo usan:
        </h2>
        <p className="text-xl text-text-main/70 font-medium" data-id="element-253">
          +500 mamás de toda Latinoamérica ya tienen su Código Hijo
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-254">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-dusty-rose/10 flex flex-col h-full hover:shadow-md transition-shadow" data-id="element-255">
            <div className="flex justify-between items-start mb-6" data-id="element-256">
              <div className="flex items-center gap-3" data-id="element-257">
                <div className="w-12 h-12 rounded-full bg-burgundy/10 flex items-center justify-center text-burgundy font-black text-lg" data-id="element-258">
                  {t.initials}
                </div>
                <div data-id="element-259">
                  <p className="font-bold text-text-main" data-id="element-260">{t.name}</p>
                  <div className="flex text-gold mt-1" data-id="element-261">
                    {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-262" />)}
                  </div>
                </div>
              </div>
            </div>

            <p className="text-text-main/80 italic leading-relaxed flex-grow mb-6" data-id="element-263">
              "{t.text}"
            </p>

            <div className="mt-auto pt-4 border-t border-dusty-rose/10 flex flex-col gap-1 text-sm text-text-main/60" data-id="element-264">
              <span className="flex items-center gap-1" data-id="element-265">
                <MapPin size={14} data-id="element-266" /> {t.location}
              </span>
              <span className="font-medium" data-id="element-267">{t.child}</span>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}